import React from "react";
import styled, { css } from "styled-components";
/**
 * Usually wrapped inside FormFieldWrapper, displays errors in a standard format across the whole UI.
 */
export const StyledError = styled.div `
  ${({ theme: { colors: { inputColors }, }, }) => css `
    color: ${inputColors.inputErrorText};
  `}
`;
export const FieldErrorMessage = ({ error, name }) => error ? React.createElement(StyledError, { "data-testid": `FormFieldError-${name}` }, error) : null;
